
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "4a27973b-f211-4596-a891-181f14281e06",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "DEINE_TENANT_ID"}`,
redirectUri: window.location.origin,
postLogoutRedirectUri: window.location.origin,
navigateToLoginRequestUrl: false
},
cache: {
cacheLocation: "localStorage",
storeAuthStateInCookie: true
},
system: {
allowRedirectInIframe: false,
windowHashTimeout: 90000,
iframeHashTimeout: 10000,
loggerOptions: {
loggerCallback: (level, message, containsPii) => {
if (containsPii) return;
console.log('[MSAL]', message);
},
logLevel: 1
}
}
};

export const loginRequest = {
scopes: ["User.Read", "Sites.Read.All", "Sites.ReadWrite.All"]
};

export const graphConfig = {
graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
siteId: "travelbrain.sharepoint.com,bb4ae473-be73-4e32-a759-b4b3ae23eaa1,ee97eb85-4115-4b78-9760-bede03b8d4a8"
};
